import { render, staticRenderFns } from "./SamlChooser.vue?vue&type=template&id=5a22422f"
import script from "./SamlChooser.vue?vue&type=script&lang=js"
export * from "./SamlChooser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports